import Neighborhoods from './static/data/new_neighborhoods';
import {combineReducers} from 'redux'
import {responsiveStateReducer} from 'redux-responsive'

const App = function(state = {active_year: 2016, active_price: 1000000,  map: false, neighborhoods: Neighborhoods.features, neighborhoods_samples: false, active_mode: 'Chance', active_probability: 0.5, price_focus: false, probability_focus: false, active_neighborhood: false, hex_arrays: false, borough_filter: false, active_hex: false, show_roads: true, explainer: true, mobile_toggle: true}, action) {
  switch(action.type) {
    case 'MAP_LOADED':
      {
        const {active_year, active_price, neighborhoods, neighborhoods_samples, active_mode, active_probability, price_focus, probability_focus, active_neighborhood, borough_filter, hex_arrays, active_hex, show_roads, explainer, mobile_toggle} = state;
        const map = action.payload.map;
        return {
          active_year,
          active_price,
          map,
          neighborhoods,
          neighborhoods_samples,
          active_mode,
          active_probability,
          price_focus,
          probability_focus,
          active_neighborhood,
          borough_filter,
          hex_arrays,
          active_hex,
          show_roads,
          explainer,
          mobile_toggle
        }
      }
    case 'GOT_NEIGHBORHOODS_SAMPLES':
      {
        const {active_year, active_price, neighborhoods, map, active_mode, active_probability, price_focus, probability_focus, active_neighborhood, borough_filter, hex_arrays, active_hex, show_roads, explainer, mobile_toggle} = state;
        const neighborhoods_samples = action.payload.neighborhoods_samples;
        return {
          active_year,
          active_price,
          map,
          neighborhoods,
          neighborhoods_samples,
          active_mode,
          active_probability,
          price_focus,
          probability_focus,
          active_neighborhood,
          borough_filter,
          hex_arrays,
          active_hex,
          show_roads,
          explainer,
          mobile_toggle
        }
      }
    case 'CHANGE_ACTIVE_YEAR':
      {
        const {active_price, map, neighborhoods, neighborhoods_samples, active_mode, active_probability, price_focus, probability_focus, active_neighborhood, borough_filter, hex_arrays, active_hex, show_roads, explainer, mobile_toggle} = state;
        const active_year = parseFloat(action.payload.year);
        return {
          active_year,
          active_price,
          map,
          neighborhoods,
          neighborhoods_samples,
          active_mode,
          active_probability,
          price_focus,
          probability_focus,
          active_neighborhood,
          borough_filter,
          hex_arrays,
          active_hex,
          show_roads,
          explainer,
          mobile_toggle
        }
      }
      case 'CHANGE_ACTIVE_PRICE':
        {
          const {active_year, map, neighborhoods, neighborhoods_samples, active_mode, active_probability, price_focus, probability_focus, active_neighborhood, borough_filter, hex_arrays, active_hex, show_roads, explainer, mobile_toggle} = state;
          const active_price = parseFloat(action.payload.price);
          return {
            active_year,
            active_price,
            map,
            neighborhoods,
            neighborhoods_samples,
            active_mode,
            active_probability,
            price_focus,
            probability_focus,
            active_neighborhood,
            borough_filter,
            hex_arrays,
            active_hex,
            show_roads,
            explainer,
            mobile_toggle
          }
        }
      case 'CHANGE_ACTIVE_MODE':
        {
          const {active_year, map, neighborhoods, neighborhoods_samples, active_price, active_probability, price_focus, probability_focus, active_neighborhood, borough_filter, hex_arrays, active_hex, show_roads, explainer, mobile_toggle} = state;
          const active_mode = action.payload.mode;
          return {
            active_year,
            active_price,
            map,
            neighborhoods,
            neighborhoods_samples,
            active_mode,
            active_probability,
            price_focus,
            probability_focus,
            active_neighborhood,
            borough_filter,
            hex_arrays,
            active_hex,
            show_roads,
            explainer,
            mobile_toggle
          }
        }
      case 'CHANGE_ACTIVE_PROBABILITY':
        {
          const {active_year, map, neighborhoods, neighborhoods_samples, active_price, active_mode, price_focus, probability_focus, active_neighborhood, borough_filter, hex_arrays, active_hex, show_roads, explainer, mobile_toggle} = state;
          const active_probability = parseFloat(action.payload.probability);
          return {
            active_year,
            active_price,
            map,
            neighborhoods,
            neighborhoods_samples,
            active_mode,
            active_probability,
            price_focus,
            probability_focus,
            active_neighborhood,
            borough_filter,
            hex_arrays,
            active_hex,
            show_roads,
            explainer,
            mobile_toggle
          }
        }
      case 'CHANGE_PRICE_FOCUS':
        {
          const {active_year, map, neighborhoods, neighborhoods_samples, active_price, active_mode, active_probability, probability_focus, active_neighborhood, borough_filter, hex_arrays, active_hex, show_roads, explainer, mobile_toggle} = state;
          const price_focus = parseFloat(action.payload.price);
          return {
            active_year,
            active_price,
            map,
            neighborhoods,
            neighborhoods_samples,
            active_mode,
            active_probability,
            price_focus,
            probability_focus,
            active_neighborhood,
            borough_filter,
            hex_arrays,
            active_hex,
            show_roads,
            explainer,
            mobile_toggle
          }
        }
      case 'CHANGE_PROBABILITY_FOCUS':
        {
          const {active_year, map, neighborhoods, neighborhoods_samples, active_price, active_mode, active_probability, price_focus, active_neighborhood, borough_filter, hex_arrays, active_hex, show_roads, explainer, mobile_toggle} = state;
          let probability_focus = false;
          if (action.payload.probability !== false) {
            probability_focus = parseFloat(action.payload.probability);
          }
          return {
            active_year,
            active_price,
            map,
            neighborhoods,
            neighborhoods_samples,
            active_mode,
            active_probability,
            price_focus,
            probability_focus,
            active_neighborhood,
            borough_filter,
            hex_arrays,
            active_hex,
            show_roads,
            explainer,
            mobile_toggle
          }
        }
      case 'SET_ACTIVE_NEIGHBORHOOD':
        {
          const {active_year, map, neighborhoods, neighborhoods_samples, active_price, active_mode, active_probability, price_focus,
           probability_focus, borough_filter, active_hex, show_roads, explainer, mobile_toggle} = state;
          const active_neighborhood = action.payload.neighborhood;
          const hex_arrays = false;
          return {
            active_year,
            active_price,
            map,
            neighborhoods,
            neighborhoods_samples,
            active_mode,
            active_probability,
            price_focus,
            probability_focus,
            active_neighborhood,
            borough_filter,
            hex_arrays,
            active_hex,
            show_roads,
            explainer,
            mobile_toggle
          }
        }
        case 'GOT_NEIGHBORHOOD_HEXES':
          {
            const {active_year, map, neighborhoods, neighborhoods_samples, active_price, active_mode, active_probability, price_focus,
             probability_focus, active_neighborhood, borough_filter, active_hex, show_roads, explainer, mobile_toggle} = state;
            const hex_arrays = action.payload;
            return {
              active_year,
              active_price,
              map,
              neighborhoods,
              neighborhoods_samples,
              active_mode,
              active_probability,
              price_focus,
              probability_focus,
              active_neighborhood,
              borough_filter,
              hex_arrays,
              active_hex,
              show_roads,
              explainer,
              mobile_toggle
            }
          }
        case 'SET_ACTIVE_HEX':
          {
            const {active_year, map, neighborhoods, neighborhoods_samples, active_price, active_mode, active_probability, price_focus,
             probability_focus, borough_filter, hex_arrays, active_neighborhood, show_roads, explainer, mobile_toggle} = state;
            const active_hex = action.payload.hex;
            return {
              active_year,
              active_price,
              map,
              neighborhoods,
              neighborhoods_samples,
              active_mode,
              active_probability,
              price_focus,
              probability_focus,
              active_neighborhood,
              borough_filter,
              hex_arrays,
              active_hex,
              show_roads,
              explainer,
              mobile_toggle
            }
          }
        case 'SET_BOROUGH_FILTER':
          {
            const {active_year, map, neighborhoods, neighborhoods_samples, active_price, active_mode, active_probability, price_focus,
             probability_focus, active_neighborhood, hex_arrays, active_hex, show_roads, explainer, mobile_toggle} = state;
            const borough_filter = action.payload.borough;
            return {
              active_year,
              active_price,
              map,
              neighborhoods,
              neighborhoods_samples,
              active_mode,
              active_probability,
              price_focus,
              probability_focus,
              active_neighborhood,
              borough_filter,
              hex_arrays,
              active_hex,
              show_roads,
              explainer,
              mobile_toggle
            }
          }
        case 'SET_SHOW_ROADS':
          {
            const {active_year, map, neighborhoods, neighborhoods_samples, active_price, active_mode, active_probability, price_focus,
             probability_focus, active_neighborhood, hex_arrays, active_hex, borough_filter, explainer, mobile_toggle} = state;
            return {
              active_year,
              active_price,
              map,
              neighborhoods,
              neighborhoods_samples,
              active_mode,
              active_probability,
              price_focus,
              probability_focus,
              active_neighborhood,
              borough_filter,
              hex_arrays,
              active_hex,
              show_roads: action.payload.value,
              explainer,
              mobile_toggle
            }
          }
        case 'SET_EXPLAINER':
          {
            const {active_year, map, neighborhoods, neighborhoods_samples, active_price, active_mode, active_probability, price_focus,
             probability_focus, active_neighborhood, hex_arrays, active_hex, borough_filter, show_roads, mobile_toggle} = state;
            return {
              active_year,
              active_price,
              map,
              neighborhoods,
              neighborhoods_samples,
              active_mode,
              active_probability,
              price_focus,
              probability_focus,
              active_neighborhood,
              borough_filter,
              hex_arrays,
              active_hex,
              show_roads,
              explainer: action.payload.value,
              mobile_toggle
            }
          }
        case 'TOGGLE_MOBILE':
          {
            const {active_year, map, neighborhoods, neighborhoods_samples, active_price, active_mode, active_probability, price_focus,
             probability_focus, active_neighborhood, hex_arrays, active_hex, borough_filter, show_roads, explainer} = state;
            return {
              active_year,
              active_price,
              map,
              neighborhoods,
              neighborhoods_samples,
              active_mode,
              active_probability,
              price_focus,
              probability_focus,
              active_neighborhood,
              borough_filter,
              hex_arrays,
              active_hex,
              show_roads,
              explainer,
              mobile_toggle: action.payload.value
            }
          }
    default:
      return state;
  }
}

export default combineReducers({
  app: App,
  browser: responsiveStateReducer
});


/** WEBPACK FOOTER **
 ** ./src/reducer.js
 **/